module.exports = __webpack_public_path__ + "static/media/profit-report.bd0b8d35.png";